import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import PAGES from '@/constants/pages';
import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';
import useCurrentPage from '@/hooks/useCurrentPage';
import useQueryParams from '@/hooks/useQueryParams';
import { useInjection } from '@/services/hooks';
import { INavigationService } from '@/services/NavigationService';
import ServiceTypes from '@/services/ServiceTypes';

/**
 * Редирект с `Cars Page` на `Models Page` происходит только в том случае, если
 * 1. Функционал страницы с моделями включен
 * 2. Ранее пользователь не посещал данную страницу или посетил `CarId Page`
 * 3. Пользователь перешел на страницу без установленных фильтров
 */
function useRedirectToModels() {
  const navigation = useInjection<INavigationService>(ServiceTypes.Navigation);

  const currentPage = useCurrentPage();
  const queryParams = useQueryParams();
  const { state } = useLocation();

  const modelsEnable = useAppSelector(rootSelectors.config.modelsEnableSelector);
  const pagesVisited = useAppSelector(rootSelectors.installation.pagesVisitedSelector);

  useEffect(() => {
    if (
      !modelsEnable ||
      pagesVisited.includes(PAGES.Models) ||
      pagesVisited.includes(PAGES.CarId)
    ) {
      return;
    }

    const lastPage = state?.lastPage;

    if (
      currentPage === PAGES.Cars &&
      lastPage !== PAGES.Models &&
      !Object.keys(queryParams).length
    ) {
      navigation.replace(PAGES.Models);
    }
  }, [currentPage]);
}

export default useRedirectToModels;
